// @ts-nocheck
import { getPartsListByModelNumber } from "@store/Framework/Services/PartFinderService";
import { getPartsList } from "@store/Framework/Services/StoreProductService";
import { PartsListModel } from "@store/Framework/Types/ApiModels";
import { ApiHandler, createHandlerChainRunner, HasOnSuccess } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandler<{ sku?: string; id?: string } & HasOnSuccess<PartsListModel>, PartsListModel>;

export const DispatchBeginLoadPartsData: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/PartFinder/BeginLoadPartsData",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    if (props.apiParameter.sku) {
        props.apiResult = await getPartsListByModelNumber(props.apiParameter.sku);
    } else if (props.apiParameter.id) {
        const models = await getPartsList(props.apiParameter.id);
        if (models) {
            props.dispatch({
                type: "Store/Data/PartFinder/CompleteLoadModels",
                result: models,
            });
        }
        if (models.length > 0) {
            props.apiResult = await getPartsListByModelNumber(models[0]);
        }
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const DispatchCompleteLoadPartsData: HandlerType = props => {
    if (props.apiResult) {
        props.dispatch({
            type: "Store/Data/PartFinder/CompleteLoadPartsData",
            result: props.apiResult,
        });
    }
};

export const chain = [
    DispatchBeginLoadPartsData,
    PopulateApiParameter,
    RequestDataFromApi,
    ExecuteOnSuccessCallback,
    DispatchCompleteLoadPartsData,
];

const loadPartsData = createHandlerChainRunner(chain, "LoadPartsData");
export default loadPartsData;
